import View from './Detail';
import enhancer from './Detail.enhancer';

export default enhancer(View);
